import { render, staticRenderFns } from "./create-update-modal.component.vue?vue&type=template&id=653cc4bc&scoped=true&"
import script from "./create-update-modal.component.vue?vue&type=script&lang=ts&"
export * from "./create-update-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./create-update-modal.component.vue?vue&type=style&index=0&id=653cc4bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653cc4bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VCol,VForm,VIcon,VRow,VSelect,VTextField,VTextarea,VTooltip})
